// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--E176e","tabs-container":"a10a3f92e9--tabs-container--CgkCk"};